<script>
    export let onClickSection;
</script>
    <div class='about'>
        <h1>Terapia</h1>
        <div class='description'>
           <p>
           { `Para mi la terapia es la creación de un espacio compartido donde analizar los problemas, dificultades y las fortalezas que tiene la persona y tomar conciencia de ellos. Un lugar donde sentirse comprendido/a y no juzgado/a, donde aprender estrategias para conseguir nuestras metas. Es un proceso único, centrado en lo individual de la persona y que se basa en la vinculación con el/la profesional. 

            Si decides dar el paso, comenzaremos con la evaluación y planteamiento de objetivos, desarrollaremos un plan de actuación, lo llevaremos a cabo y finalmente, realizaremos un seguimiento de lo conseguido. 
            `
            }</p>
             <h2 class='section'>En qué puedo ayudar</h2>
            <p>Los problemas que podemos trabajar y en los cuales tengo experiencia son: </p>
                <ul>
                    <li><p>Ansiedad</p></li>
                    <li><p>Estrés</p></li>
                    <li><p>Síntomas depresivos</p></li>
                    <li><p>Crisis vitales</p></li>
                    <li><p>Problemas de pareja</p></li>
                    <li><p>Dificultades cognitivas</p></li>
                    <li><p>Trastorno mental grave</p></li>
            </ul>
            <br/>
            <p class="contact-me"> De forma presencial siguiendo el protocolo de seguridad o si lo prefieres en formato online. Si quieres más información, no dudes en <a on:click={() => onClickSection('contact')} href='#contact'>contactarme</a>.</p>
        </div>
    </div>
<style> 

    .description {
        width: 90%;
    }
    ul {
        margin-top: 30px;
    }
 	
    a {
        text-decoration: underline !important;
    }
    .section {
        margin-top: 40px;
    }

</style>